<cb-dialog class="flex-col" dialogHeading="Edit Build Programme Activity">
    <mat-tab-group mat-stretch-tabs="false" class="cb-margin-bottom-2x">
        <mat-tab label="Activity Details">
            <div class="scrollable-tab-content">
                @if (data.canSetSupplier) {
                    <form
                        #editSupplierForm="ngForm"
                        class="cb-margin-top-2x supplierForm flex-row layoutGap-30"
                    >
                        <cb-business-account-autocomplete-scroller
                            class="cb-margin-right flex"
                            label="Supplier"
                            name="supplierSearch"
                            [(ngModel)]="selectedBusinessAccount"
                            [required]="true"
                            [requireMatch]="true"
                            [matchProps]="['id']"
                            [disabled]="!buildProgrammeActivity?.rules?.canSetSupplier"
                            (optionSelected)="setSupplier()"
                            [status]="statusQuery"
                            [searchType]="searchTypeQuery"
                        >
                        </cb-business-account-autocomplete-scroller>
                        <cb-business-accounts-input-find-cards
                            label="Supplier"
                            #businessAccountInput
                            [(ngModel)]="selectedBusinessAccount"
                            name="selectedSupplier"
                            [buttonOnly]="true"
                            [disabled]="!buildProgrammeActivity?.rules?.canSetSupplier"
                            (change)="setSupplier()"
                            [searchParams]="businessAccountFindParams"
                        >
                        </cb-business-accounts-input-find-cards>
                    </form>
                }
                <form #editSsrForm="ngForm" class="cb-margin-bottom-2x flex-row layoutGap-30">
                    <div class="flex-col flex">
                        <cb-display-value-new label="Postal Address">
                            <div>
                                <div>{{ mappedItem.businessAccountAddress.street | cbDasher }}</div>
                                <div>{{ mappedItem.businessAccountAddress.suburb | cbDasher }}</div>
                                <div>{{ mappedItem.businessAccountAddress.city | cbDasher }}</div>
                                <div>
                                    {{ mappedItem.businessAccountAddress.regionName | cbDasher }}
                                </div>
                                <div>
                                    {{ mappedItem.businessAccountAddress.postCode | cbDasher }}
                                </div>
                            </div>
                        </cb-display-value-new>
                        <cb-display-value-new label="SSR Email Addresses">
                            <div class="mat-body-2">
                                @if (
                                    !(mappedItem.businessAccountContactOrderRolesEmails.length > 0)
                                ) {
                                    <p>-</p>
                                }
                                @for (
                                    email of mappedItem.businessAccountContactOrderRolesEmails;
                                    track email
                                ) {
                                    <p>
                                        {{ email }}
                                    </p>
                                }
                            </div>
                        </cb-display-value-new>
                        <cb-text-area
                            label="Comments"
                            class="cb-margin-bottom"
                            name="comments"
                            [disabled]="!canEditComments()"
                            [(ngModel)]="buildProgrammeActivity.ssrComment"
                            [ngModelOptions]="{ standalone: true }"
                        ></cb-text-area>
                        @if (mappedItem.valueRetainedPercentage > 0) {
                            <span class="cb-margin-bottom start-center flex-row">
                                <mat-icon class="mat-accent">info_circle</mat-icon>
                                <span class="mat-body-2"
                                    >&nbsp;This Activity has retained a value of
                                    {{ mappedItem.valueRetainedPercentage }}%</span
                                >
                            </span>
                        }
                    </div>
                    <div class="flex-col flex">
                        <cb-display-value-new
                            label="Activity"
                            [value]="getActivityName()"
                        ></cb-display-value-new>
                        @if (mappedItem.hasComplianceStatement) {
                            <span class="mat-body-2" style="margin-bottom: 8px">
                                <mat-icon class="mat-accent">info_circle</mat-icon>
                                &nbsp; {{ mappedItem.complianceStatement }}
                            </span>
                        }
                        <cb-edit-build-programme-activity
                            [buildProgrammeActivity]="buildProgrammeActivity"
                        >
                        </cb-edit-build-programme-activity>
                    </div>
                </form>
                <div class="standardTable">
                    <table>
                        <thead>
                            <tr>
                                <td>Cost Type</td>
                                <td>Code</td>
                                <td>Item</td>
                                <td>Supplier Quote Number</td>
                                <td>UOM</td>
                                <td>Lot No.</td>
                                <td style="min-width: 135px" class="right-align">
                                    Unallocated Quantity
                                </td>
                                <td class="right-align">Quantity</td>
                                <td class="right-align">Rate</td>
                                <td class="right-align">Subtotal</td>
                                <td class="actions"></td>
                            </tr>
                        </thead>
                        <tbody>
                            @for (lineItem of mappedItem.lineItems; track lineItem) {
                                <tr>
                                    <td>{{ lineItem.costTypeLabel | cbDasher }}</td>
                                    <td>{{ lineItem.code | cbDasher }}</td>
                                    <td>
                                        {{ lineItem.description | cbDasher }}
                                        <ul>
                                            @for (
                                                attribute of lineItem.attributes;
                                                track attribute
                                            ) {
                                                <li>
                                                    {{ attribute.attributeName }} :
                                                    {{ attribute.attributeValue }},
                                                    {{ attribute.note }}
                                                </li>
                                            }
                                            @if (lineItem.manualColour) {
                                                <li>Manual Colour : {{ lineItem.manualColour }}</li>
                                            }
                                            @if (lineItem.specItemNote) {
                                                <li>Note : {{ lineItem.specItemNote }}</li>
                                            }
                                        </ul>
                                    </td>
                                    <td>{{ lineItem.supplierQuoteNumber | cbDasher }}</td>
                                    <td>{{ lineItem.uom | cbDasher }}</td>
                                    <td>{{ lineItem.lotNumber | cbDasher }}</td>
                                    <td class="right-align">{{ lineItem.unallocatedQuantity }}</td>
                                    <td class="right-align">{{ lineItem.quantity }}</td>
                                    <td class="right-align">{{ lineItem.rate | cbCurrency }}</td>
                                    <td class="right-align">
                                        {{ lineItem.subtotal | cbCurrency }}
                                    </td>
                                    <td class="actions right-align">
                                        <button
                                            class="cb-margin-right"
                                            mat-icon-button
                                            [disabled]="getEditDisabled(lineItem)"
                                            (click)="editLineItem(lineItem)"
                                        >
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button
                                            mat-icon-button
                                            [disabled]="getEditDisabled(lineItem)"
                                            (click)="removeLineItem(lineItem.id)"
                                        >
                                            <mat-icon>remove_circle</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                                @if (lineItem.notes) {
                                    <tr>
                                        <td style="width: 30px">
                                            <mat-icon class="cb-small-icon"
                                                >insert_drive_file</mat-icon
                                            >
                                        </td>
                                        <td></td>
                                        <td>
                                            <span class="mat-body-2 preserve-line-breaks">{{
                                                lineItem.notes
                                            }}</span>
                                        </td>
                                        <td
                                            [attr.colspan]="
                                                data.lotType === LOT_TYPE_ENUM.Unit ? 8 : 7
                                            "
                                        ></td>
                                    </tr>
                                }
                            }
                            <tr>
                                <td
                                    [attr.colspan]="data.lotType === LOT_TYPE_ENUM.Unit ? 10 : 9"
                                ></td>
                                <td class="actions">
                                    <button
                                        mat-icon-button
                                        [disabled]="getAddDisabled()"
                                        (click)="addLineItemsDialog()"
                                    >
                                        <mat-icon>add</mat-icon>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td [attr.colspan]="data.lotType === LOT_TYPE_ENUM.Unit ? 10 : 9">
                                    <div class="end-center flex-row">
                                        <span class="mat-body-strong">
                                            Total: {{ mappedItem.lineItemTotal() | cbCurrency }}
                                        </span>
                                    </div>
                                </td>
                                <td class="actions"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Activity Relationships">
            @if (activityRelationships) {
                <cb-build-programme-activity-relationships
                    class="tab-content-margin"
                    [buildProgrammeActivity]="buildProgrammeActivity"
                    [activityRelationships]="activityRelationships"
                >
                </cb-build-programme-activity-relationships>
            }
        </mat-tab>
    </mat-tab-group>

    <div actions>
        @if (canConvertToManualOrder) {
            <button
                mat-raised-button
                color="accent"
                [disabled]="
                    saveInProgress || !buildProgrammeActivity?.rules?.canConvertToManualOrder
                "
                (click)="convertToManualOrder()"
            >
                Convert To Manual Order
            </button>
        }
        @if (canReview.value) {
            <button mat-raised-button color="primary" (click)="review()">Review</button>
        }
        @if (canCompleteSSR) {
            @if (buildProgrammeActivity.activity.code == BUILD_COMPLETE_ACTIVITY_CODE) {
                <button
                    mat-raised-button
                    [disabled]="buildProgrammeActivity.statusId != BUILD_PROGRAMME_ACTIVITY_STATUS_ENUM.Confirmed"
                    (click)="submitSSrForApproval()"
                >
                    Submit for Approval
                </button>
            } @else {
                <button
                    mat-raised-button
                    color="accent"
                    [disabled]="saveInProgress || !buildProgrammeActivity?.rules?.canCompleteSsr"
                    (click)="setSsrCompleted()"
                >
                    Complete SSR
                </button>
            }
        }
        @if (canConfirmSSR) {
            <span
                class="inline-tooltip-wrapper cb-margin-left cb-margin-right"
                [matTooltip]="getCostActionDisabledText()"
                [matTooltipDisabled]="!(isCostActionDisabled)"
                matTooltipPosition="above"
            >
              <button
                  mat-raised-button
                  color="accent"
                  [disabled]="saveInProgress || !buildProgrammeActivity?.rules?.canConfirmSsr || !saveButton.disabled || isCostActionDisabled"
                  (click)="setSsrConfirmed()"
              >
                Confirm SSR
              </button>
            </span>
        }
        <button
            mat-raised-button
            color="primary"
            #saveButton
            [disabled]="saveInProgress || !editSsrForm.dirty || !editSsrForm.valid"
            (click)="saveBuildProgrammeActivity(editSsrForm)"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Close</button>
    </div>
</cb-dialog>
